import * as fs from "../../../util/fs";
import PromiseBB from "bluebird";
import { tmpName } from "tmp";
function zipFiles(files) {
    if (files.length === 0) {
        return PromiseBB.resolve(undefined);
    }
    const Zip = require("node-7z");
    const task = new Zip();
    return new PromiseBB((resolve, reject) => {
        tmpName({
            postfix: ".7z",
        }, (err, tmpPath) => (err !== null ? reject(err) : resolve(tmpPath)));
    }).then((tmpPath) => task.add(tmpPath, files, { ssw: true }).then(() => tmpPath));
}
function submitFeedback(nexus, title, message, feedbackFiles, anonymous, hash) {
    let archive;
    return zipFiles(feedbackFiles)
        .then((tmpPath) => {
        archive = tmpPath;
        return nexus.sendFeedback(title, message, tmpPath, anonymous, hash);
    })
        .finally(() => {
        if (archive !== undefined) {
            fs.removeAsync(archive);
        }
    });
}
export default submitFeedback;
